import theme from '../../../../../lib/theme';
import { SpacerBlockProps } from './SpacerBlock';

const {
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

const getScale = (gutter: string): string => {
  switch (gutter) {
    case 'none':
      return '0';
    case 'xxs':
      return scale.xxs;
    case 'xs':
      return scale.xs;
    case 's':
      return scale.s;
    case 'm':
      return scale.m;
    case 'l':
      return scale.l;
    case 'xl':
      return scale.xl;
    case 'xxl':
      return scale.xxl;
    default:
      return '0';
  }
}

export default ({ block: { desktop_spacing, mobile_spacing } }: SpacerBlockProps) => ({
  container: {
    padding: `${getScale(mobile_spacing)} 0 ${getScale(mobile_spacing)} 0`,

    [media.s.up]: {
      padding: `${getScale(desktop_spacing)} 0 ${getScale(desktop_spacing)} 0`,
    }
  },
});